import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
export function BottomSheet({ open, onClose, children }) {
    const [mounted, setMounted] = useState(false);
    useEffect(() => {
        if (open) {
            setMounted(true);
            requestAnimationFrame(() => {
                // Force reflow for animation
                document.body.offsetHeight;
            });
        }
    }, [open]);
    const handleTransitionEnd = () => {
        if (!open)
            setMounted(false);
    };
    if (!mounted && !open)
        return null;
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: `sheet-backdrop ${open ? 'visible' : ''}`, onClick: onClose }), _jsxs("div", { className: `sheet-content no-scrollbar ${open ? 'open' : ''}`, onTransitionEnd: handleTransitionEnd, children: [_jsx("div", { className: "w-10 h-1 bg-white/20 rounded-full mx-auto mt-3 mb-2" }), children] })] }));
}
